import React from "react"
import ReactDOM from "react-dom"
import AccordionAndTextContainer from "./accordion-and-text-container-component"

export default class AccordionAndTextContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<AccordionAndTextContainer {...self.modelJson} />, self.elem)
  }
}
